import { FEEDBACKS_LOADING } from "../actions/types";
import { CREATE_FEEDBACK } from "../actions/types";
import { EDIT_FEEDBACK } from "../actions/types";
import { DELETE_FEEDBACK } from "../actions/types";
import { DELETE_FEEDBACK_FAIL } from "../actions/types";
import { EDIT_FEEDBACK_FAIL } from "../actions/types";
import { CREATE_FEEDBACK_FAIL } from "../actions/types";
import { FEEDBACKS_LOADING_END } from "../actions/types";
import { GET_FEEDBACKS } from "../actions/types";
import firebase from "firebase";

export const getFeedbacks = () => async (dispatch) => {
  await dispatch({ type: FEEDBACKS_LOADING });
  await firebase
    .firestore()
    .collection("feedbacks")
    .onSnapshot(async (snapshot) => {
      let users = [];
      for (let doc of snapshot.docs) {
        users.push({ id: doc.id, ...doc.data() });
      }
      await dispatch({ type: GET_FEEDBACKS, feedbacks: users });
      await dispatch({ type: FEEDBACKS_LOADING_END });
    });
};
export const createFeedback = (feedback) => async (dispatch) => {
  await dispatch({ type: FEEDBACKS_LOADING });
  await firebase
    .firestore()
    .collection("feedbacks")
    .add({ ...feedback })
    .then((res) => {
      dispatch({ type: CREATE_FEEDBACK });
      dispatch({ type: FEEDBACKS_LOADING_END });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: CREATE_FEEDBACK_FAIL });
      dispatch({ type: FEEDBACKS_LOADING_END });
    });
};
export const editFeedback = (feedback, id) => async (dispatch) => {
  await dispatch({ type: FEEDBACKS_LOADING });
  await firebase
    .firestore()
    .collection("feedbacks")
    .doc(id)
    .update({ ...feedback })
    .then((res) => {
      dispatch({ type: EDIT_FEEDBACK });
      dispatch({ type: FEEDBACKS_LOADING_END });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: EDIT_FEEDBACK_FAIL });
      dispatch({ type: FEEDBACKS_LOADING_END });
    });
};

export const deleteFeedback = (id) => async (dispatch) => {
  await dispatch({ type: FEEDBACKS_LOADING });
  await firebase
    .firestore()
    .collection("feedbacks")
    .doc(id)
    .delete()
    .then((res) => {
      dispatch({ type: DELETE_FEEDBACK });
      dispatch({ type: FEEDBACKS_LOADING_END });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: DELETE_FEEDBACK_FAIL });
      dispatch({ type: FEEDBACKS_LOADING_END });
    });
};
